import { memo, useMemo } from 'react';
import type React from 'react';
import { EvoMfeApp } from '@user-interfaces/evo-app-container';
import { useFeedbackCollectorParams } from '@/hooks/use-feedback-collector-params';
import type { FeatureFeedbackCollectorProps } from '@/types/feedbackCollector';

/**
 * A reusable feedback collector component that wraps the EvoMfeApp
 * micro-frontend host for the evo-feature-feedback-collector.
 *
 * Memoised to prevent unnecessary re-renders that cause the OC widget
 * to flicker when parent components re-render.
 */
export const FeatureFeedbackCollector: React.FC<FeatureFeedbackCollectorProps> = memo(({
  feature,
  className,
}) => {
  const params = useFeedbackCollectorParams(feature);

  const componentParams = useMemo(() => {
    if (!params) return null;
    return {
      ...params,
      reDisplayAfterDays: 0,
    };
  }, [params]);

  if (!componentParams) {
    return null;
  }

  return (
    <EvoMfeApp
      componentName="evo-feature-feedback-collector"
      componentVersion="1"
      componentParams={componentParams}
      className={className}
    />
  );
});

FeatureFeedbackCollector.displayName = 'FeatureFeedbackCollector';

export default FeatureFeedbackCollector;
